/** A LOSAN sales season: "SS26", "AW25", etc. */
export type Season = string;

/**
 * LOSAN seasons don't follow the natural calendar:
 *   SS26 = "Spring/Summer 2026" — actually SOLD Sep–Nov 2025 in B2B campaigns
 *   AW26 = "Autumn/Winter 2026" — sold roughly Mar–Jun 2026
 *
 * The dashboard works with whatever seasons exist in the data — see
 * `seasons.json` for the chronologically ordered list returned by the
 * extractor.
 */

/** "SS26" → "SS25" (one year earlier, same SS/AW half). */
export function previousSeason(s: Season): Season | null {
  const m = /^(SS|AW)(\d{2})$/.exec(s);
  if (!m) return null;
  const yy = Number(m[2]);
  if (!Number.isFinite(yy) || yy <= 0) return null;
  return `${m[1]}${String(yy - 1).padStart(2, '0')}`;
}
